<template>
    <b-dropdown
            split
            :split-variant="color"
            :split-href="link"
            :variant="color + ' active'"
            size="sm"
            right
            target="_blank"
    >
        <template slot="button-content" target="_blank">
            <font-awesome-icon icon="cloud-download-alt"/>
            <span>{{t('Export')}}</span>
        </template>
        <b-dropdown-item :href="link" target="_blank">{{t('Download pdf')}}</b-dropdown-item>
        <b-dropdown-item :href="link + '/rtf'" target="_blank">{{t('Download rtf')}}</b-dropdown-item>
    </b-dropdown>
</template>
<script>

    export default {
        props: {
            link: {
                type: String,
                required: true,
            },
            color: {
                type: String,
                required: false,
                default: 'success'
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/applications/download-button.vue